import { useState } from "react";
import { Link } from "react-router-dom";
import BrokerSignupForm from "./SignUpFromComponends/VendorSignUpFrom";
import CustomerSignupForm from "./SignUpFromComponends/UserSignUpFrom";





const Signup = () => {
  // Default: Customer form is open
  const [selectedForm, setSelectedForm] = useState("customer");

  return (
    <div className="min-h-screen flex items-center justify-center p-4 mt-10 bg-gray-100">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6">
        {/* Top toggle buttons */}
        <div className="flex justify-center gap-4 mb-6">
          <button
            onClick={() => setSelectedForm("customer")}
            className={`px-4 py-2 rounded ${
              selectedForm === "customer"
                ? "bg-green-600 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            Signup as Customer
          </button>
          <button
            onClick={() => setSelectedForm("broker")}
            className={`px-4 py-2 rounded ${
              selectedForm === "broker"
                ? "bg-indigo-600 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            Signup as Broker
          </button>
        </div>

        {/* Render selected form */}
        {selectedForm === "broker" && <BrokerSignupForm onSuccess={() => setSelectedForm("customer")} />}
        {selectedForm === "customer" && <CustomerSignupForm onSuccess={() => setSelectedForm("customer")} />}

        <p className="mt-4 text-center text-sm text-gray-600">
          Already have an account?{" "}
          <Link to="/log-in" className="text-indigo-600 hover:underline">
            Sign In
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;
